import axios from "axios";

const state = {
  provincesData: null,
  isRequestingProvinces: false,
  lodingProvinces: false,
};

const getters = {
  getProvincesData(state) {
    return state.provincesData;
  },
  getLodingProvinces(state) {
    return state.lodingProvinces;
  },
};

const mutations = {
  setProvincesData(state, data) {
    state.provincesData = data;
  },
  setLodingProvinces(state, data) {
    state.lodingProvinces = data;
  },
};

const actions = {
  async getProvincesDataFromServer({ commit, state }) {
    if (!state.isRequestingProvinces) {
      commit("setLodingProvinces", true);

      state.isRequestingProvinces = true;
      await axios
        .get("front/area")
        .then((response) => {
          commit("setProvincesData", response.data.data.provinces);
          commit("setLodingProvinces", false);
        })
        .finally(() => {
          commit("setLodingProvinces", false);
        });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
